// Demo page: NextAdmin /ui-elements/dialogs (form dialog) with the field and actions from /form-layouts.
import { useMutation } from '@tanstack/react-query';
import { updateConversationMutation } from '../../generated/api/@tanstack/react-query.gen.js';
import { zConversationUpdate } from '../../generated/api/zod.gen.js';
import { Form, FormActions, TextFormField, useZodForm } from '../../components/form/index.js';
import { Modal } from '../../components/ui/Modal.js';

const renameSchema = zConversationUpdate.pick({ topic: true }).required({ topic: true });

interface Props {
  conversationId: string;
  topic: string;
  onClose: () => void;
  onRenamed: () => void;
}

/** Renames one conversation; the server's 1 to 256 character limit comes from the generated schema. */
export function ConversationRenameDialog({ conversationId, topic, onClose, onRenamed }: Props) {
  const update = useMutation(updateConversationMutation());
  const form = useZodForm(renameSchema, { defaultValues: { topic } });

  const submit = async (values: { topic: string }) => {
    if (values.topic.trim() !== topic) {
      await update.mutateAsync({ path: { id: conversationId }, body: { topic: values.topic.trim() } });
      onRenamed();
    }
    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Rename conversation" maxWidth="sm">
      <Form form={form} onSubmit={submit}>
        <TextFormField name="topic" label="Name" autoComplete="off" />
        <FormActions submitLabel="Save" onCancel={onClose} />
      </Form>
    </Modal>
  );
}
